import { IconFullScreen } from '../../components/iconSet/IconSet'
import Logo from '../../images/icons/logo_icon.png'
import WarningIcon from '../../images/icons/warning.png'
import Image1 from '../../images/icons/image1.png'
import Image2 from '../../images/icons/image2.png'
import Image3 from '../../images/icons/image3.png'
import Image4 from '../../images/icons/image4.png'
import Arrow from '../../images/icons/arrow.png'

const UserDeletePage = () => {

    const handleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();   
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();   
            }
        }
    }

    return (
        <div className="user-delete-page-wrapper">
            <div className="header">
                <div className="left-side">
                    <div>
                        <img src={Logo} alt="Logo" />
                    </div>
                    <span>Udha</span>
                </div>
                <div className="right-side">
                    <div onClick={(e) => handleFullScreen()}>
                        <IconFullScreen color='var(--color-main-white)' width='1.5rem'/>
                    </div>
                </div>
            </div>
            <div className='data-wrapper'>
                <div className='data'>
                    <span className='title'>Delete User Account</span>
                    <div className='container-1'>
                        <span className='sub-title'>Are you sure you want to delete your account?</span>

                        <ul>
                            <li>
                                <div className="circle">
                                    <img src={WarningIcon} alt="" className="warnIcon" />
                                </div>
                                Deleting your account will permanently remove all your data and cannot be undone. This includes
                                your profile information, preferences, and any associated content.
                            </li>
                            <li>
                                <div className="circle">
                                    <img src={WarningIcon} alt="" className="warnIcon" />
                                </div>
                                If you proceed, you will no longer have access to your account and all associated services. You
                                will need to create a new account if you wish to use our platform in the future.
                            </li>
                
                            <li>
                                <div className="circle">
                                    <img src={WarningIcon} alt="" className="warnIcon" />
                                </div>
                                If you're certain you want to delete your account, please follow one of any option below.
                            </li>
                        </ul>

                        <div className="sub-title-style">
                            <span className="title">Option 1 ( Using App )</span>
                        </div>

                        <div className="optionContent">
                            <img src={Image1} alt="" />
                            <img src={Arrow} alt="" className="arrow" />
                            <img src={Image2} alt="" />
                            <img src={Arrow} alt="" className="arrow" />
                            <img src={Image3} alt="" />
                            <img src={Arrow} alt="" className="arrow" />
                            <img src={Image4} alt="" />
                        </div>

                        <div className="sub-title-style" style={{ marginTop: '1.5rem' }}>
                            <span className="title">Option 2 ( Submit a request )</span>
                        </div>

                        <p>To request the deletion of your user account, please submit a request using the form provided below. One of our colleagues will contact you to verify your information and proceed with the account deletion. Your request will be processed within 90 days </p>

                        <div className='optionContent' style={{ width: '100%' }}>
                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeqXYHCYD3BBIeHoB-38nTl_S_GftddYdHVpHKu1ELMJ2IKbA/viewform?embedded=true" width="90%" height={732} frameBorder="0" marginHeight={0} marginWidth={0}>Loading…</iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserDeletePage